<template>
  <Select
    v-model="ddd"
    @on-select="ddddd"
    :clearable="clearable"
    @on-clear="clear"
    :multiple="multiple"
  >
    <Option v-for="(x, index) in wanggeList" :value="x.id" :key="index">{{
      x.name
    }}</Option>
  </Select>
</template>
<script>
export default {
  props: ["id", "clearable", "multiple"],
  data() {
    return {
      wanggeList: [],
      ddd: [],
    };
  },
  methods: {
    ddddd(v) {
      setTimeout(() => {
        this.$emit("update:id", this.ddd);
        this.$emit("update:name", v.label);
      }, 500);
    },
    clear(v) {
      this.$emit("update:id", "");
      this.$emit("update:name", "");
    },
    getWange() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.rule + "/fence/list",
        data: {},
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data.dataList;
        this.wanggeList = data;
      });
    },
  },
  mounted() {
    this.getWange();
    console.log(this.id);
  },
  watch: {
    id(v) {
      this.ddd = v;
    },
  },
};
</script>




// WEBPACK FOOTER //
// src/components/common/selectFence.vue